export default __webpack_public_path__ + "static/media/acesso_info.c363554e.png";